import { useEffect, useRef } from 'react';
import UsageTrackingService from '../services/UsageTrackingService';

// Fires a usage-tracking event whenever `isOpen` transitions to true.
// Dialogs stay mounted with `open` toggling, so this keys off `isOpen`
// rather than mount, and guards against re-firing on unrelated re-renders.
export function useTrackUsage(componentName, componentType, feature, isOpen = true) {
    const wasOpenRef = useRef(false);

    useEffect(() => {
        if (isOpen && !wasOpenRef.current) {
            UsageTrackingService.trackOpen(componentName, componentType, feature);
        }
        wasOpenRef.current = isOpen;
    }, [isOpen, componentName, componentType, feature]);
}
